import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Helmet from '../../component/common/Helmet';
import './oscars2026.css';

const PASSWORD_TO_POOL = {
  'thesecretagent!': {
    route: '/oscars2026-matteo-julia/',
    accessKey: 'oscars2026-matteo-julia-access-granted',
  },
  'hamnet2026!': {
    route: '/oscars2026-matteo-kitti/',
    accessKey: 'oscars2026-matteo-kitti-access-granted',
  },
};

const Oscars2026Gateway = () => {
  const history = useHistory();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    const targetPool = PASSWORD_TO_POOL[password];

    if (!targetPool) {
      setError('Wrong password.');
      return;
    }

    window.localStorage.setItem(targetPool.accessKey, 'true');
    history.push(targetPool.route);
  };

  return (
    <div className="active-dark oscars2026-page">
      <Helmet pageTitle="Oscars 2026 Predictions" disableTitleSuffix />
      <main className="oscars2026-shell">
        <section className="oscars2026-auth">
          <div className="oscars2026-auth__card">
            <p className="oscars2026-kicker">Private Page</p>
            <h1>Oscars 2026</h1>
            <p className="oscars2026-summary">
              Enter your password to open the correct predictions pool.
            </p>

            <form className="oscars2026-auth__form" onSubmit={handleSubmit}>
              <label htmlFor="oscars-password-gateway">Password</label>
              <input
                id="oscars-password-gateway"
                type="password"
                value={password}
                onChange={(event) => {
                  setPassword(event.target.value);
                  if (error) {
                    setError('');
                  }
                }}
                autoFocus
              />
              <button type="submit">Continue</button>
            </form>

            {error ? <div className="oscars2026-auth__error">{error}</div> : null}
          </div>
        </section>
      </main>
    </div>
  );
};

export default Oscars2026Gateway;
